export class Unit {
  symbol: string;

  baseUnit: string;

  a: number;

  b: number;

  c: number;

  d: number;

  constructor(
    uid: string,
    baseUnit: string,
    a: number,
    b: number,
    c: number,
    d: number,
  ) {
    this.symbol = uid;
    this.baseUnit = baseUnit;
    this.a = a;
    this.b = b;
    this.c = c;
    this.d = d;
  }

  get isBase() {
    return this.symbol === this.baseUnit;
  }

  toBase(value: number) {
    return this.isBase
      ? value
      : (this.a + this.b * value) / (this.c + this.d * value);
  }

  fromBase(baseValue: number) {
    return this.isBase
      ? baseValue
      : (this.a - this.c * baseValue) / (this.d * baseValue - this.b);
  }
}
